import { render } from "./UploadPreference.vue?vue&type=template&id=1fde538e"
import script from "./UploadPreference.vue?vue&type=script&lang=js"
export * from "./UploadPreference.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__